import { api } from "@/lib/api";

export const listMyCourses = () => api.get("/courses").then((r) => r.data);
export const listAdminCourses = (params) =>
  api.get("/admin/courses", { params }).then((r) => r.data);
export const listPublishedCatalog = (params) =>
  api.get("/courses/public/published", { params }).then((r) => r.data);
export const getPublicCourse = (id) =>
  api.get(`/courses/public/${id}`).then((r) => r.data);
export const getCourse = (id) => api.get(`/courses/${id}`).then((r) => r.data);
export const createBlankCourse = (body) =>
  api.post("/courses", body).then((r) => r.data);
export const aiGenerateCourse = (body, files) => {
  // Phase 23 — when files are attached use multipart/form-data. When
  // none are attached the classic JSON path is preserved.
  if (!files || files.length === 0) {
    return api.post("/courses/ai-generate", body).then((r) => r.data);
  }
  const fd = new FormData();
  fd.append("payload", JSON.stringify(body));
  files.forEach((f) => fd.append("files", f));
  return api
    .post("/courses/ai-generate", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const getSourceDocument = (courseId, index) =>
  api
    .get(`/courses/${courseId}/source-documents/${index}`)
    .then((r) => r.data);
export const aiGenerationStatus = (courseId) =>
  api.get(`/courses/${courseId}/ai-generation`).then((r) => r.data);
export const updateCourseMeta = (id, patch) =>
  api.put(`/courses/${id}`, patch).then((r) => r.data);
export const updateChapter = (courseId, chapterId, chapter) =>
  api.put(`/courses/${courseId}/chapters/${chapterId}`, chapter).then((r) => r.data);
export const addChapter = (courseId, title) =>
  api.post(`/courses/${courseId}/chapters`, { title }).then((r) => r.data);
export const deleteChapter = (courseId, chapterId) =>
  api.delete(`/courses/${courseId}/chapters/${chapterId}`).then((r) => r.data);
export const reorderChapters = (courseId, chapterIds) =>
  api
    .post(`/courses/${courseId}/reorder-chapters`, { chapter_ids: chapterIds })
    .then((r) => r.data);
export const regenerateChapter = (courseId, chapterIndex, instructions) =>
  api
    .post(`/courses/${courseId}/regenerate-chapter`, {
      chapter_index: chapterIndex,
      instructions,
    })
    .then((r) => r.data);
export const aiAppendChapter = (courseId, prompt, targetLevel) =>
  api
    .post(`/courses/${courseId}/chapters/ai-append`, {
      prompt,
      target_level: targetLevel || undefined,
    })
    .then((r) => r.data);
export const boostProficiency = (courseId, body) =>
  api
    .post(`/courses/${courseId}/boost-proficiency`, body)
    .then((r) => r.data);
export const publishCourse = (id) =>
  api.post(`/courses/${id}/publish`).then((r) => r.data);
export const archiveCourse = (id) =>
  api.post(`/courses/${id}/archive`).then((r) => r.data);
export const deleteCourse = (id) =>
  api.delete(`/courses/${id}`).then((r) => r.data);

export const formatPrice = (pricing) => {
  if (!pricing) return "Free";
  const { amount_inr, amount_usd, currency_primary } = pricing;
  if (currency_primary === "INR" && amount_inr) return `₹${amount_inr}`;
  if (currency_primary === "USD" && amount_usd) return `$${amount_usd}`;
  if (amount_inr) return `₹${amount_inr}`;
  if (amount_usd) return `$${amount_usd}`;
  return "Not priced";
};

export const COVER_COLORS = ["amber", "stone", "emerald", "sky", "rose", "violet"];
export const coverBg = (c) =>
  ({
    amber: "bg-amber-100 text-amber-900 border-amber-300",
    stone: "bg-stone-100 text-stone-900 border-stone-300",
    emerald: "bg-emerald-100 text-emerald-900 border-emerald-300",
    sky: "bg-sky-100 text-sky-900 border-sky-300",
    rose: "bg-rose-100 text-rose-900 border-rose-300",
    violet: "bg-violet-100 text-violet-900 border-violet-300",
  }[c] || "bg-stone-100 text-stone-900 border-stone-300");

export const statusPill = (s) =>
  ({
    draft: "bg-stone-100 text-stone-700 border-stone-300",
    published: "bg-emerald-100 text-emerald-800 border-emerald-300",
    archived: "bg-zinc-100 text-zinc-700 border-zinc-300",
  }[s] || "bg-stone-100 text-stone-700 border-stone-300");
